import { useQuery } from "@tanstack/react-query";
import { ProductService } from "../services/productService";

export const useAdminProduct = (id: String) =>
  useQuery({
    queryKey: [],
    queryFn: ProductService.getAllProducts,
  });

export const useHomeProducts = () =>
  useQuery({
    queryKey: [],
    queryFn: ProductService.getAllProducts,
  });

export const useProducts = (page: number = 1, limit: number = 20, search?: string, sortBy?: string, sortOrder?: "asc" | "desc") => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["products", page, limit, search, sortBy, sortOrder],
    queryFn: ({ queryKey }: any) => {
      const [, pageNum, limitNum, searchTerm, sortField, sortDirection] = queryKey;
      return ProductService.getAllProductsPaginated(pageNum, limitNum, searchTerm, sortField, sortDirection);
    },
  });

  return {
    products: data?.products || [],
    total: data?.total || 0,
    totalPages: data?.totalPages || 0,
    currentPage: data?.currentPage || 1,
    isLoading,
    error,
    refetch,
  };
};

export const useProductSearch = (query: string) => {
  return useQuery({
    queryKey: ["products-search", query],
    queryFn: () => ProductService.searchProducts(query),
    enabled: !!query, // Only run when query is not empty
  });
};
